export default "__VITE_ASSET__469649ba__"